<div class="top-panel">
  <div class="logo">
    <!--<span routerLink="userhome">MidOffice</span>-->
    <img [src]="'assets/logo-dark.png'" alt="Logo" routerLink="userhome">
  </div>
  <div class="centerHeaderMenu">
    <i class="fa fa-bars mobiled" (click)="toggleMobileMenu()"></i>
    <div class="centerHeaderMenu1" [class.show]="isMobileMenuOpen">
      <div *ngFor="let parent of parentMenus" class="menu-item">
        <div class="menu-link">
          <i class="fas fa-cog"></i> {{ parent.menuName }}
        </div>
        <div class="dropdown">
          <a *ngFor="let child of parent.children" (click)="navigateOrReload(child.url)">
            {{
            child.menuName
            }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="rightHeaderBox">
    <div class="usernamebox">
      <span> Welcome {{username}}</span>
    </div>
    <div class="search-box">

      <div class="search-toggle" [ngClass]="{ opened: isSearchOpen, closed: !isSearchOpen }">
        <!-- Open Button -->
        <button *ngIf="!isSearchOpen" title="Click to Show Search Bar" class="search-icon icon-search"
          (click)="toggleSearch()" type="button">
          <i class="fa fa-search"></i>
        </button>

        <!-- Close Button -->
        <button *ngIf="isSearchOpen" title="Click to Hide Search Bar" class="search-icon icon-close"
          (click)="toggleSearch()" type="button">
          <i class="fa fa-close"></i>
        </button>
      </div>

      <div class="search-container" [class.opened]="isSearchOpen">
        <form class="d-flex" role="search">
          <input class="form-control me-2" type="search" placeholder="Search in app..." aria-label="Search" />
        </form>
      </div>

    </div>
    <button (click)="logoutuser()" class="logoutuser" matTooltip="Logout ({{username}})" matTooltipPosition="below">
      <i class="fa-solid fa-right-from-bracket"></i>
      <span class="tooltip-text position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
        {{ getsession().hours + "hr:" + getsession().minutes + "min" }}
      </span>
    </button>
  </div>
</div>